module.exports = __webpack_public_path__ + "img/家装-黑金花大理石.e0d6f3dc.jpg";